import { IEvent, IHost } from "@Interfaces";
import { EVENT_TYPE, getIfSlotsAvailable } from "@Utils";

export const getBillingStateNonMandatory = ({
    event,
    eventData,
    hostData,
}: {
    event: IEvent.IStore;
    eventData: IEvent.IEventData;
    hostData: IHost.IHostData;
}) => {
    const eventType = eventData.type;
    const areSlotsAvailable: boolean = getIfSlotsAvailable({ eventData });
    const {
        paymentInfo: { otherListings: selectedUpsellListingsQuantities },
    }: IEvent.IStore = event;

    return (
        !!hostData?.billing_state_non_mandatory &&
        // check if any merchnadise needs address
        !(eventType === EVENT_TYPE.MERCHANDISE
            ? areSlotsAvailable &&
              !eventData?.metadata?.merchandise?.no_address_needed
            : Object.values(selectedUpsellListingsQuantities).some(
                  o => "quantity" in o
              ))
    );
};
